import { UpdateSupplierPayloadInterface } from '../../../../../shared/interfaces/survey-meta-data.interface';
import { Snapshot } from '../../../../shared/interfaces/snapshot';
import { SupplierSnapshot } from './supplier-snapshot';

export class SupplierUpdateSnapshot
  implements Snapshot<UpdateSupplierPayloadInterface>
{
  private _suppliers = new Map<number, SupplierSnapshot>();

  constructor(private _payload: UpdateSupplierPayloadInterface) {}

  get(): UpdateSupplierPayloadInterface {
    return this._payload;
  }

  update(payload: UpdateSupplierPayloadInterface) {
    this._payload = payload;

    for (let supplier of payload.suppliers) {
      const snapshot = this._suppliers.get(supplier.suppliers[0].id);
      if (snapshot) {
        snapshot.update(supplier);
      }
    }
  }

  restore(): void {
    this._suppliers.forEach((supplier) => supplier.restore());
  }

  take(): void {
    for (let supplier of this._payload.suppliers) {
      const snapshot = new SupplierSnapshot(supplier);
      snapshot.take();

      this._suppliers.set(supplier.suppliers[0].id, snapshot);
    }
  }

  exists(): boolean {
    return true;
  }

  equal(other: UpdateSupplierPayloadInterface): boolean {
    return this._payload.blend_id === other.blend_id;
  }
}
